import React, { useCallback, useEffect, useState } from 'react';

import { FormLogs } from '../../components/FormLogs';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import { Skeleton } from 'primereact/skeleton';

import api from '../../api/api';

export default function EditarLogsPage(props) {

    const initialLogs = {
        id: '',
        usuario: '',
        updated: '',
        cadastroId: '',
        cadastro: '',
        acao: '',
        conteudo: '',
        penultimo: '',
        antepenultimo: ''
    };

    const [logs, setLogs] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingLogs, setErrorGettingLogs] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idLogs] = useState(props.match.params.id)

    const getLogs = useCallback(async () => {
        setIsLoading(true);

        try {
            const response = await api.get(`logs/${idLogs}`)

            console.log(response.data);

            setLogs({
                id: response.data.id,
                usuario: response.data.usuario,
                updated: response.data.updated,
                cadastroId: response.data.cadastroId,
                cadastro: response.data.cadastro,
                acao: response.data.acao,
                conteudo: response.data.conteudo,
                penultimo: response.data.penultimo ? JSON.stringify(response.data.penultimo, null, 2) : "",
                antepenultimo: response.data.antepenultimo ? JSON.stringify(response.data.antepenultimo, null, 2) : ""
            });


            setErrorGettingLogs(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingLogs(true)
        }

        setIsLoading(false);
    }, [idLogs]);

    useEffect(() => {

        async function logs() {
            await getLogs();
        };
        logs();

    }, [getLogs])

    return (
        <>
            <MenuMain >
                {
                    errorGettingLogs ? (
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={getLogs}
                            isLoading={isLoading}
                        />
                    ) : !logs ? (
                        <Skeleton height="300px" />
                    ) : (
                        <FormLogs
                            defaultValues={logs}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                    )
                }


            </MenuMain>
            <AppFooter />
        </>
    );
}